export const MODERATOR_DECISION = 'moderator_decision';
export const MODERATOR = 'moderator';
export const REVIEW_ACTION = 'reviewed';

// For each content, API provides a history of actions applied to that content
// At the moment, we are using magic strings spread arround code, but we should not
// Starting this constant and let's migrate everything with baby steps
export const HISTORY_CONTENT_ACTIONS = {
    TOP_COMMENTS_EXCLUDED: 'top_content_excluded',
    TOP_COMMENTS_REINCLUDED: 'top_content_reincluded',
    // ...continue
};

export const CONTENT_ACTIONS = {
    SHARE: 'share',
    MODERATE: 'moderate',
    EDITOR_PICK: 'editor_pick',
    EDITOR_UNPICK: 'editor_unpick',
    TOP_COMMENTS_EXCLUDE: 'top_comments_exclude',
    TOP_COMMENTS_REINCLUDE: 'top_comments_reinclude',
};

export const CONTENT_ACTION_SOURCES = {
    CONTENT: 'content',
    BULK: 'bulk',
    BATCH_SUBMIT: 'batch_submit',
};
